import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Modal, Button} from 'react-bootstrap';
import RndModal from '../../../components/modals/RndModal';

const ViewEmailContentModal = ({ email, onClose }) => {
  if (!email) {
    return null;
  }

  return (
    <RndModal
      show={true}
      onHide={onClose}
      backdrop="static"
      enforceFocus={false}
      bsSize="large"
    >
      <Modal.Header closeButton>
        <Modal.Title>Email Content</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div style={{ marginBottom: '15px' }}>
            <strong>From:</strong> {email.msg_from}<br />
            <strong>To:</strong> {email.msg_to}<br />
            <strong>Subject:</strong> {email.msg_subject}<br />
            <strong>Date:</strong> {moment(email.msg_date).format('MM/DD/YYYY hh:mm:ss A')}<br />
            <strong>Id:</strong> {email.msg_id}
          </div>
          <hr />
          <div
            style={{ marginTop: '15px' }}
            dangerouslySetInnerHTML={{ __html: email.msg_body }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="default" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </RndModal>
  );
};

ViewEmailContentModal.propTypes = {
  email: PropTypes.shape({
    msg_from: PropTypes.string,
    msg_to: PropTypes.string,
    msg_subject: PropTypes.string,
    msg_date: PropTypes.string,
    msg_id: PropTypes.string,
    msg_body: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ViewEmailContentModal; 